// if url doesn't have http:// or https://, add it
export function addHttp(url: string): string {
  if (!url.includes('http://') && !url.includes('https://')) {
    return `https://${url}`;
  }
  return url;
}
